<ra-modal
    [title]="(mode === 'edit' ? 'document.edit.chart.titleEdit' : 'document.edit.chart.titleCreate') | translate"
    size="wide"
    [disabled]="saving()"
    (close)="close()">

    <div class="wizard">

        <!-- Etapas: dá para voltar a qualquer uma; para frente, só depois do tipo (e dos
             dados, para a aparência). -->
        <ol class="steps" [attr.aria-label]="'document.edit.chart.stepsLabel' | translate">
            @for (item of steps; track item.key; let i = $index) {
                <li>
                    @if (i > 0) {
                        <span class="step-line" [class.done]="stepIndex() >= i" aria-hidden="true"></span>
                    }
                    <button
                        type="button"
                        class="step"
                        [class.current]="step() === item.key"
                        [class.done]="stepIndex() > i"
                        [disabled]="step() === item.key || !canGo(item.key)"
                        [attr.aria-current]="step() === item.key ? 'step' : null"
                        (click)="goTo(item.key)">
                        <span class="step-num" aria-hidden="true">
                            @if (stepIndex() > i) {
                                <ra-icon icon="tick" varColor="currentColor" [size]="12" />
                            } @else {
                                {{ i + 1 }}
                            }
                        </span>
                        <span class="step-label">{{ item.labelKey | translate }}</span>
                    </button>
                </li>
            }
        </ol>

        <div class="body">
            @if (step() === 'type') {
                <!-- ── 1. Tipo ─────────────────────────────────────────────────── -->
                <h3 class="sub-h">{{ 'document.edit.chart.type.heading' | translate }}</h3>
                <p class="sub-p">{{ 'document.edit.chart.type.sub' | translate }}</p>

                <div class="types" role="radiogroup" [attr.aria-label]="'document.edit.chart.type.heading' | translate">
                    @for (option of kinds; track option.key) {
                        <button
                            type="button"
                            class="type"
                            role="radio"
                            [class.current]="kind() === option.key"
                            [attr.aria-checked]="kind() === option.key"
                            (click)="pickKind(option.key)"
                            (dblclick)="pickKindAndGo(option.key)">
                            <span class="type-thumb" aria-hidden="true">
                                <svg viewBox="0 0 120 72">
                                    @switch (option.key) {
                                        @case ('column') {
                                            <path class="base" d="M8 64h104" />
                                            <rect class="c1" x="14" y="36" width="8" height="28" rx="1.5" />
                                            <rect class="c2" x="23" y="44" width="8" height="20" rx="1.5" />
                                            <rect class="c1" x="40" y="26" width="8" height="38" rx="1.5" />
                                            <rect class="c2" x="49" y="32" width="8" height="32" rx="1.5" />
                                            <rect class="c1" x="66" y="40" width="8" height="24" rx="1.5" />
                                            <rect class="c2" x="75" y="30" width="8" height="34" rx="1.5" />
                                            <rect class="c1" x="92" y="16" width="8" height="48" rx="1.5" />
                                            <rect class="c2" x="101" y="22" width="8" height="42" rx="1.5" />
                                        }
                                        @case ('bar') {
                                            <path class="base" d="M18 6v60" />
                                            <rect class="c1" x="18" y="10" width="86" height="8" rx="1.5" />
                                            <rect class="c1" x="18" y="24" width="66" height="8" rx="1.5" />
                                            <rect class="c1" x="18" y="38" width="48" height="8" rx="1.5" />
                                            <rect class="c1" x="18" y="52" width="30" height="8" rx="1.5" />
                                        }
                                        @case ('stacked') {
                                            <path class="base" d="M8 64h104" />
                                            <rect class="c1" x="18" y="44" width="12" height="20" />
                                            <rect class="c2" x="18" y="32" width="12" height="12" />
                                            <rect class="c3" x="18" y="26" width="12" height="6" />
                                            <rect class="c1" x="44" y="38" width="12" height="26" />
                                            <rect class="c2" x="44" y="24" width="12" height="14" />
                                            <rect class="c3" x="44" y="16" width="12" height="8" />
                                            <rect class="c1" x="70" y="46" width="12" height="18" />
                                            <rect class="c2" x="70" y="36" width="12" height="10" />
                                            <rect class="c3" x="70" y="30" width="12" height="6" />
                                            <rect class="c1" x="96" y="34" width="12" height="30" />
                                            <rect class="c2" x="96" y="18" width="12" height="16" />
                                            <rect class="c3" x="96" y="10" width="12" height="8" />
                                        }
                                        @case ('combo') {
                                            <path class="base" d="M8 64h104" />
                                            <rect class="c1" x="16" y="40" width="12" height="24" rx="1.5" />
                                            <rect class="c1" x="42" y="30" width="12" height="34" rx="1.5" />
                                            <rect class="c1" x="68" y="42" width="12" height="22" rx="1.5" />
                                            <rect class="c1" x="94" y="22" width="12" height="42" rx="1.5" />
                                            <path class="l2" d="M22 34 48 22 74 30 100 12" />
                                            <circle class="d2" cx="22" cy="34" r="2.5" />
                                            <circle class="d2" cx="48" cy="22" r="2.5" />
                                            <circle class="d2" cx="74" cy="30" r="2.5" />
                                            <circle class="d2" cx="100" cy="12" r="2.5" />
                                        }
                                        @case ('line') {
                                            <path class="base" d="M8 64h104" />
                                            <path class="l1" d="M10 50c14-6 20-20 32-16s18 12 30-4 22-16 38-14" />
                                            <path class="l2" d="M10 58c14-2 24-12 36-10s18 4 30-6 20-8 34-12" />
                                        }
                                        @case ('area') {
                                            <path class="base" d="M8 64h104" />
                                            <path class="a1" d="M10 48c14-6 20-18 32-16s18 10 30-4 22-14 38-14V64H10Z" />
                                            <path class="l1" d="M10 48c14-6 20-18 32-16s18 10 30-4 22-14 38-14" />
                                        }
                                        @case ('pie') {
                                            <path class="c1 slice" d="M60 36 60 10A26 26 0 0 1 75.28 57.03Z" />
                                            <path class="c2 slice" d="M60 36 75.28 57.03A26 26 0 0 1 35.27 44.03Z" />
                                            <path class="c3 slice" d="M60 36 35.27 44.03A26 26 0 0 1 42.2 17.05Z" />
                                            <path class="c4 slice" d="M60 36 42.2 17.05A26 26 0 0 1 60 10Z" />
                                        }
                                        @case ('donut') {
                                            <path class="c1 slice" d="M60 36 60 10A26 26 0 0 1 75.28 57.03Z" />
                                            <path class="c2 slice" d="M60 36 75.28 57.03A26 26 0 0 1 35.27 44.03Z" />
                                            <path class="c3 slice" d="M60 36 35.27 44.03A26 26 0 0 1 42.2 17.05Z" />
                                            <path class="c4 slice" d="M60 36 42.2 17.05A26 26 0 0 1 60 10Z" />
                                            <circle class="hole" cx="60" cy="36" r="15" />
                                        }
                                    }
                                </svg>
                            </span>
                            <span class="type-name">{{ option.labelKey | translate }}</span>
                            <span class="type-hint">{{ option.hintKey | translate }}</span>
                            <span class="type-check" aria-hidden="true">
                                <ra-icon icon="tick" varColor="currentColor" [size]="12" />
                            </span>
                        </button>
                    }
                </div>
                <p class="tip">{{ 'document.edit.chart.type.tip' | translate }}</p>
            } @else {
                <div class="split">
                    <div class="side">
                        @if (step() === 'data') {
                            <!-- ── 2. Dados ────────────────────────────────────────── -->
                            <h3 class="sub-h">{{ 'document.edit.chart.data.heading' | translate }}</h3>
                            <p class="sub-p">{{ 'document.edit.chart.data.sub' | translate }}</p>

                            <div class="sources">
                                <button type="button" class="source" [class.on]="pasteOpen()" (click)="togglePaste()">
                                    <ra-icon icon="copy" varColor="currentColor" [size]="16" />
                                    {{ 'document.edit.chart.data.paste' | translate }}
                                </button>
                                <label class="source">
                                    <ra-icon icon="document-upload" varColor="currentColor" [size]="16" />
                                    {{ 'document.edit.chart.data.import' | translate }}
                                    <input
                                        type="file"
                                        class="file-input"
                                        accept=".csv,.tsv,.txt,text/csv,text/plain"
                                        (change)="onFile($event)" />
                                </label>
                                <div class="source-wrap">
                                    <button
                                        type="button"
                                        class="source"
                                        [class.on]="tablesOpen()"
                                        [disabled]="docTables().length === 0"
                                        [title]="docTables().length === 0 ? ('document.edit.chart.data.noTables' | translate) : ''"
                                        (click)="toggleTables()">
                                        <ra-icon icon="table" varColor="currentColor" [size]="16" />
                                        {{ 'document.edit.chart.data.useTable' | translate }}
                                    </button>
                                    @if (tablesOpen()) {
                                        <div class="pop" role="menu">
                                            <p class="pop-title">{{ 'document.edit.chart.data.tablesTitle' | translate }}</p>
                                            @for (table of docTables(); track table.id) {
                                                <button type="button" class="pop-item" role="menuitem" (click)="useTable(table)">
                                                    <span class="pop-icon"><ra-icon icon="table" varColor="currentColor" [size]="16" /></span>
                                                    <span class="pop-text">
                                                        <b>{{ table.heading }}</b>
                                                        <small>{{ 'document.edit.chart.data.tableMeta' | translate: { section: table.sectionName, count: table.rowsCount } }}</small>
                                                    </span>
                                                </button>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>

                            @if (pasteOpen()) {
                                <div class="paste-box">
                                    <textarea
                                        rows="4"
                                        [attr.aria-label]="'document.edit.chart.data.paste' | translate"
                                        [placeholder]="'document.edit.chart.data.pastePlaceholder' | translate"
                                        [value]="pasteText()"
                                        (input)="pasteText.set($any($event.target).value)"
                                        (paste)="onPasteBox($event)"></textarea>
                                    <div class="paste-foot">
                                        <span>{{ 'document.edit.chart.data.pasteHint' | translate }}</span>
                                        <button type="button" class="link" [disabled]="!pasteText().trim()" (click)="applyPaste()">
                                            {{ 'document.edit.chart.data.pasteApply' | translate }}
                                        </button>
                                    </div>
                                </div>
                            }

                            @if (notice(); as note) {
                                <div class="notice" [class.error]="note.tone === 'error'" role="status">
                                    <ra-icon [icon]="note.tone === 'error' ? 'warning' : 'tick'" varColor="currentColor" [size]="16" />
                                    <span>{{ note.text }}</span>
                                </div>
                            }
                            @if (isExample()) {
                                <div class="notice example">
                                    <span>{{ 'document.edit.chart.data.example' | translate }}</span>
                                    <button type="button" class="link" (click)="clearData()">
                                        {{ 'document.edit.chart.data.clear' | translate }}
                                    </button>
                                </div>
                            }

                            <!-- A tabela de dados: 1ª coluna as categorias, uma coluna por série. -->
                            <div class="grid" role="table" [attr.aria-label]="'document.edit.chart.data.gridLabel' | translate">
                                <div class="grid-row head" role="row" [style.grid-template-columns]="gridTemplate()">
                                    <div class="cell" role="columnheader">
                                        <span class="tag">{{ 'document.edit.chart.data.categories' | translate }}</span>
                                        <input
                                            data-cell="-1:0"
                                            [value]="columns()[0]"
                                            [placeholder]="'document.edit.chart.data.categoriesPlaceholder' | translate"
                                            [attr.aria-label]="'document.edit.chart.data.categories' | translate"
                                            (input)="setHeader(0, $any($event.target).value)"
                                            (paste)="onCellPaste($event, -1, 0)" />
                                    </div>
                                    @for (name of columns().slice(1); track $index; let j = $index) {
                                        <div class="cell series" role="columnheader" [class.dim]="isPie() && j > 0">
                                            <span class="tag">
                                                <i class="dot" [style.background-color]="seriesColors()[j % seriesColors().length]"></i>
                                                @if (kind() === 'combo') {
                                                    {{ (j === 0 ? 'document.edit.chart.data.asColumns' : 'document.edit.chart.data.asLine') | translate }}
                                                } @else if (isPie()) {
                                                    {{ (j === 0 ? 'document.edit.chart.data.asValue' : 'document.edit.chart.data.unused') | translate }}
                                                } @else {
                                                    {{ 'document.edit.chart.data.series' | translate: { n: j + 1 } }}
                                                }
                                            </span>
                                            <input
                                                [attr.data-cell]="'-1:' + (j + 1)"
                                                [value]="name"
                                                [placeholder]="'document.edit.chart.data.seriesPlaceholder' | translate: { n: j + 1 }"
                                                [attr.aria-label]="'document.edit.chart.data.seriesName' | translate: { n: j + 1 }"
                                                (input)="setHeader(j + 1, $any($event.target).value)"
                                                (paste)="onCellPaste($event, -1, j + 1)" />
                                            <button
                                                type="button"
                                                class="icon-btn danger"
                                                [disabled]="seriesCount() <= 1"
                                                [attr.aria-label]="'document.edit.chart.data.removeSeries' | translate"
                                                [title]="'document.edit.chart.data.removeSeries' | translate"
                                                (click)="removeSeries(j + 1)">
                                                <ra-icon icon="close" varColor="currentColor" [size]="9" />
                                            </button>
                                        </div>
                                    }
                                    <div class="cell end">
                                        <button
                                            type="button"
                                            class="add-col"
                                            [disabled]="seriesCount() >= maxSeries"
                                            [attr.aria-label]="'document.edit.chart.data.addSeries' | translate"
                                            [title]="(seriesCount() >= maxSeries ? 'document.edit.chart.data.maxSeries' : 'document.edit.chart.data.addSeries') | translate"
                                            (click)="addSeries()">
                                            <ra-icon icon="add" varColor="currentColor" [size]="14" />
                                        </button>
                                    </div>
                                </div>

                                @for (row of rows(); track $index; let r = $index) {
                                    <div class="grid-row" role="row" [style.grid-template-columns]="gridTemplate()">
                                        @for (cell of row; track $index; let c = $index) {
                                            <div
                                                class="cell"
                                                role="cell"
                                                [class.num]="c > 0"
                                                [class.bad]="c > 0 && isBadNumber(cell)"
                                                [class.dim]="isPie() && c > 1">
                                                <input
                                                    [attr.data-cell]="r + ':' + c"
                                                    [value]="cell"
                                                    [attr.inputmode]="c > 0 ? 'decimal' : null"
                                                    [placeholder]="c === 0 ? ('document.edit.chart.data.categoryPlaceholder' | translate) : '0'"
                                                    [attr.aria-label]="'document.edit.chart.data.cellLabel' | translate: { row: r + 1, column: c + 1 }"
                                                    [attr.aria-invalid]="c > 0 && isBadNumber(cell)"
                                                    [title]="c > 0 && isBadNumber(cell) ? ('document.edit.chart.data.notNumber' | translate) : ''"
                                                    (input)="setCell(r, c, $any($event.target).value)"
                                                    (keydown)="onCellKeydown($event, r, c)"
                                                    (paste)="onCellPaste($event, r, c)" />
                                            </div>
                                        }
                                        <div class="cell end">
                                            <button
                                                type="button"
                                                class="icon-btn danger"
                                                [disabled]="rows().length <= 1"
                                                [attr.aria-label]="'document.edit.chart.data.removeRow' | translate"
                                                [title]="'document.edit.chart.data.removeRow' | translate"
                                                (click)="removeRow(r)">
                                                <ra-icon icon="trash" varColor="currentColor" [size]="14" />
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>

                            <button type="button" class="add-row" [disabled]="rows().length >= limits.MAX_ROWS" (click)="addRow()">
                                <ra-icon icon="add" varColor="currentColor" [size]="14" />
                                {{ 'document.edit.chart.data.addRow' | translate }}
                            </button>

                            @if (isPie() && seriesCount() > 1) {
                                <p class="tip warn">
                                    {{ 'document.edit.chart.data.pieNote' | translate: { name: columns()[1] || ('document.edit.chart.data.series' | translate: { n: 1 }) } }}
                                </p>
                            }
                            <p class="tip">{{ 'document.edit.chart.data.tip' | translate }}</p>
                        } @else {
                            <!-- ── 3. Aparência ────────────────────────────────────── -->
                            <h3 class="sub-h">{{ 'document.edit.chart.look.heading' | translate }}</h3>
                            <p class="sub-p">{{ 'document.edit.chart.look.sub' | translate }}</p>

                            <label class="field">
                                <span>{{ 'document.edit.chart.look.title' | translate }}</span>
                                <input
                                    [value]="title()"
                                    [maxLength]="limits.MAX_TITLE_LENGTH"
                                    [placeholder]="'document.edit.chart.look.titlePlaceholder' | translate"
                                    (input)="title.set($any($event.target).value)" />
                            </label>

                            <p class="look-title">{{ 'document.edit.chart.look.colors' | translate }}</p>
                            <div class="palettes">
                                @for (palette of palettes; track palette.key) {
                                    <button
                                        type="button"
                                        class="palette"
                                        [class.current]="style().palette === palette.key"
                                        [attr.aria-pressed]="style().palette === palette.key"
                                        (click)="setStyle('palette', palette.key)">
                                        <span class="palette-dots" aria-hidden="true">
                                            @for (color of palette.colors.slice(0, 5); track $index) {
                                                <i [style.background-color]="color"></i>
                                            }
                                        </span>
                                        <span>{{ palette.labelKey | translate }}</span>
                                    </button>
                                }
                            </div>

                            <p class="look-title">{{ 'document.edit.chart.look.legend' | translate }}</p>
                            <div class="look-chips">
                                @for (option of legends; track option.key) {
                                    <button
                                        type="button"
                                        class="look-chip"
                                        [class.current]="style().legend === option.key"
                                        [attr.aria-pressed]="style().legend === option.key"
                                        (click)="setStyle('legend', option.key)">
                                        {{ option.labelKey | translate }}
                                    </button>
                                }
                            </div>

                            <!-- Só aparece o que muda o desenho do tipo escolhido: a pizza mostra
                                 percentuais, então o formato dos números não vale nela. Na rosca ele
                                 formata o total do centro. -->
                            @if (showUnit()) {
                                <p class="look-title">{{ 'document.edit.chart.look.unit' | translate }}</p>
                                <div class="look-chips">
                                    @for (option of units; track option.key) {
                                        <button
                                            type="button"
                                            class="look-chip"
                                            [class.current]="style().unit === option.key"
                                            [attr.aria-pressed]="style().unit === option.key"
                                            (click)="setStyle('unit', option.key)">
                                            {{ option.labelKey | translate }}
                                        </button>
                                    }
                                </div>
                                @if (kind() === 'donut') {
                                    <p class="look-hint">{{ 'document.edit.chart.look.unitDonutHint' | translate }}</p>
                                }
                            }

                            <p class="look-title">{{ 'document.edit.chart.look.height' | translate }}</p>
                            <div class="look-chips">
                                @for (option of heights; track option.key) {
                                    <button
                                        type="button"
                                        class="look-chip"
                                        [class.current]="style().height === option.key"
                                        [attr.aria-pressed]="style().height === option.key"
                                        (click)="setStyle('height', option.key)">
                                        {{ option.labelKey | translate }}
                                    </button>
                                }
                            </div>

                            <div class="switches">
                                <button
                                    type="button"
                                    class="look-switch"
                                    role="switch"
                                    [attr.aria-checked]="style().values"
                                    (click)="setStyle('values', !style().values)">
                                    <span>
                                        {{ (isPie() ? 'document.edit.chart.look.percents' : 'document.edit.chart.look.values') | translate }}
                                        <small>{{ (isPie() ? 'document.edit.chart.look.percentsHint' : 'document.edit.chart.look.valuesHint') | translate }}</small>
                                    </span>
                                    <span class="look-toggle" [class.on]="style().values"></span>
                                </button>
                                <!-- Grade só existe com eixos; linha suave, só onde há linha. -->
                                @if (!isPie()) {
                                    <button
                                        type="button"
                                        class="look-switch"
                                        role="switch"
                                        [attr.aria-checked]="style().gridLines"
                                        (click)="setStyle('gridLines', !style().gridLines)">
                                        <span>
                                            {{ 'document.edit.chart.look.grid' | translate }}
                                            <small>{{ 'document.edit.chart.look.gridHint' | translate }}</small>
                                        </span>
                                        <span class="look-toggle" [class.on]="style().gridLines"></span>
                                    </button>
                                }
                                @if (isLine()) {
                                    <button
                                        type="button"
                                        class="look-switch"
                                        role="switch"
                                        [attr.aria-checked]="style().smooth"
                                        (click)="setStyle('smooth', !style().smooth)">
                                        <span>
                                            {{ 'document.edit.chart.look.smooth' | translate }}
                                            <small>{{ 'document.edit.chart.look.smoothHint' | translate }}</small>
                                        </span>
                                        <span class="look-toggle" [class.on]="style().smooth"></span>
                                    </button>
                                }
                            </div>
                        }
                    </div>

                    <!-- Prévia: o mesmo SVG que vai para o PDF. -->
                    <aside class="preview" [attr.aria-label]="'document.edit.chart.preview.label' | translate">
                        <div class="preview-head">
                            <span class="preview-label">{{ 'document.edit.chart.preview.label' | translate }}</span>
                            <span class="preview-kind">
                                <ra-icon icon="chart" varColor="currentColor" [size]="14" />
                                {{ kindOption().labelKey | translate }}
                                <span aria-hidden="true">·</span>
                                <button type="button" class="link" (click)="goTo('type')">
                                    {{ 'document.edit.chart.preview.change' | translate }}
                                </button>
                            </span>
                        </div>
                        <div class="paper">
                            @if (preview(); as svg) {
                                <div class="paper-svg" role="img" [attr.aria-label]="title() || (kindOption().labelKey | translate)" [innerHTML]="svg"></div>
                            } @else {
                                <p class="paper-empty">
                                    {{ (chartRender.ready() ? 'document.edit.chart.preview.empty' : 'document.edit.chart.preview.loading') | translate }}
                                </p>
                            }
                        </div>
                        <p class="preview-foot">{{ 'document.edit.chart.preview.foot' | translate }}</p>
                    </aside>
                </div>
            }
        </div>

        <div class="foot">
            <span class="foot-info">
                {{ 'document.edit.chart.footer.step' | translate: { n: stepIndex() + 1 } }}
                <span aria-hidden="true">·</span>
                @switch (step()) {
                    @case ('type') {
                        {{ kind() ? (kindOption().labelKey | translate) : ('document.edit.chart.footer.chooseType' | translate) }}
                    }
                    @case ('data') {
                        {{ 'document.edit.chart.footer.counts' | translate: { rows: countLabel('rows', rows().length), series: countLabel('series', seriesCount()) } }}
                    }
                    @default {
                        {{ 'document.edit.chart.footer.later' | translate }}
                    }
                }
            </span>
            <div class="foot-actions">
                @if (step() !== 'type') {
                    <ra-button
                        class="foot-button"
                        type="primary-outline"
                        [label]="'document.edit.chart.footer.back' | translate"
                        [disabled]="saving()"
                        (click)="back()" />
                }
                <ra-button
                    class="foot-button"
                    type="primary"
                    [label]="(step() === 'look' ? (mode === 'edit' ? 'document.edit.chart.footer.save' : 'document.edit.chart.footer.insert') : 'document.edit.chart.footer.next') | translate"
                    [icon]="step() === 'look' ? 'tick' : 'arrow-right'"
                    [disabled]="!canContinue()"
                    [loading]="saving()"
                    (click)="next()" />
            </div>
        </div>
    </div>
</ra-modal>
